export { default as filesize } from 'filesize';

export const bytesToMB = size => size / 1024 / 1024;
export const MBToBytes = size => size * 1024 * 1024;
export const percentage = (amount, total) => Math.round((amount / total) * 100);
